import { create, doMocked, isMocked, read, update } from "../api";
import { key } from "./action";
export const SERVICE_ENDPOINT = "user";
export const SERVICE_ENDPOINT_READ_USER = `${SERVICE_ENDPOINT}/read`;
export const SERVICE_ENDPOINT_UPDATE_USER = `${SERVICE_ENDPOINT}/`;
export const SERVICE_ENDPOINT_LOGIN = `${SERVICE_ENDPOINT}/login`;
export const SERVICE_ENDPOINT_LOGOUT = `${SERVICE_ENDPOINT}/logout`;
export const SERVICE_ENDPOINT_RESET_USER = `${SERVICE_ENDPOINT}/reset`;
export const SERVICE_ENDPOINT_VERIFY_CODE = `${SERVICE_ENDPOINT}/verify_code`;

let authenticated = false;

export const readUser = () => {
  if (isMocked()) {
    if (authenticated) {
      return doMocked(key, SERVICE_ENDPOINT_READ_USER);
    } else {
      return undefined;
    }
  }
  return read(`${SERVICE_ENDPOINT}`, null, true);
};

export const updateUser = (body) => {
  if (isMocked()) return doMocked(key, SERVICE_ENDPOINT_UPDATE_USER);
  return update(`${SERVICE_ENDPOINT}`, body, null, true);
};

export const login = (body) => {
  if (isMocked()) {
    authenticated = true;
    return doMocked(key, SERVICE_ENDPOINT_LOGIN);
  }
  return create(`${SERVICE_ENDPOINT}/login`, body);
};

export const logout = () => {
  if (isMocked()) {
    authenticated = false;
    return doMocked(key, SERVICE_ENDPOINT_LOGOUT);
  }
  return read(`${SERVICE_ENDPOINT}/logout`);
};


export const resetUser = (body) => {
  if (isMocked()) return doMocked(key, SERVICE_ENDPOINT_RESET_USER);
  return create(`${SERVICE_ENDPOINT}/reset`, body);
};

export const verifyCode = (body) => {
  if (isMocked()) {
    authenticated = false;
    return doMocked(key, SERVICE_ENDPOINT_VERIFY_CODE);
  }
  return create(`${SERVICE_ENDPOINT}/verify_code`, body);
};